module.exports = __webpack_public_path__ + "static/media/2022_S_CP_Tradi_TI212_2couches_HD_01.149bf6bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2022_S_CP_Tradi_TI212_2couches_HD_01.jpg
// module id = 1159
// module chunks = 0